/**
 * Chế độ backend toàn app — quyết định service layer gọi Supabase hay PHP API.
 *
 * Đặt env khi build:
 *   VITE_BACKEND_MODE=supabase   (mặc định — vẫn dùng Supabase)
 *   VITE_BACKEND_MODE=php-api    (self-host: gọi src/lib/api.ts)
 *
 * Quy ước phase 2B-1: chỉ những service ĐÃ chuẩn bị mới đọc giá trị này.
 * Các service khác vẫn chạy Supabase cho tới khi endpoint PHP sẵn sàng.
 */
export type BackendMode = "supabase" | "php-api";

const raw = (import.meta.env.VITE_BACKEND_MODE as string | undefined)?.toLowerCase();
export const BACKEND_MODE: BackendMode = raw === "php-api" ? "php-api" : "supabase";

export const isPhpApi = () => BACKEND_MODE === "php-api";
export const isSupabase = () => BACKEND_MODE === "supabase";

/** Lỗi rõ ràng khi gọi endpoint PHP chưa hoàn thiện. */
export class BackendNotImplementedError extends Error {
  constructor(what: string) {
    super(`Backend PHP chưa hỗ trợ "${what}". Vui lòng đợi endpoint hoàn thiện hoặc dùng VITE_BACKEND_MODE=supabase.`);
    this.name = "BackendNotImplementedError";
  }
}
